export default __webpack_public_path__ + "static/flipSectionBg-bc84ddffa6132db01a59e4074bfd7747.png";